import { memo, useState } from "react";
import { Link } from "react-router-dom";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import Breadcrumb from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";

import { useConnectionStore } from "stores/ConnectionStore";
import { ActionState } from "stores/lib";

import { getSearchedServices } from "utility/connections";

import useAnalytics from "effect/use_analytics";

import Sources from "external/sources";

import LoaderModal from "layouts/components/LoaderModal";

import EnvironmentPossibleSource from "../Environment/Sources/PossibleSources/Source";

// -----------------------------------------------------------------------------

const EnvironmentSourcesSearchPage = memo(
  function EnvironmentSourcesSearchPage() {
    useAnalytics("Environment: Sources Search");

    //
    const [connectionStore, connectionActions] = useConnectionStore();
    const [search, setSearch] = useState("");

    //
    if (connectionStore.loadConnections.state === ActionState.INITIAL) {
      connectionActions.loadConnections({ reload: true });
    }

    //
    const searchTermsRaw = search.toLocaleLowerCase().trim();
    const searchTerms = searchTermsRaw.length > 0 ? search.split(/\s+/g) : [];

    const services = Sources.services;
    const sources =
      searchTerms.length > 0
        ? getSearchedServices(services, searchTerms)
        : services;

    //
    return connectionStore.loadConnections.state === ActionState.IN_PROGRESS ? (
      <LoaderModal />
    ) : (
      <>
        <Breadcrumbs>
          <Breadcrumb
            underline="none"
            color="inherit"
            component={Link}
            to="/environment/sources"
          >
            Environment
          </Breadcrumb>
          <Breadcrumb
            underline="none"
            color="inherit"
            component={Link}
            to="/environment/sources"
          >
            Sources
          </Breadcrumb>
          <span />
        </Breadcrumbs>
        <Typography variant="h4" fontWeight="bold" sx={{ mt: 1, mr: 1 }}>
          All Available Sources
        </Typography>

        <TextField
          fullWidth
          variant="outlined"
          sx={{ mt: 2, backgroundColor: "#FFF" }}
          placeholder="Search sources..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment:
              searchTerms.length > 0 ? (
                <InputAdornment position="end">
                  <CancelIcon
                    onClick={() => setSearch("")}
                    style={{ cursor: "pointer" }}
                  />
                </InputAdornment>
              ) : null,
          }}
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />

        {sources.length > 0 ? (
          <Grid container spacing={1} sx={{ mt: 2 }}>
            {sources.map((source) => (
              <EnvironmentPossibleSource
                source={source as any}
                key={source.name}
                hideDismissButton
              />
            ))}
          </Grid>
        ) : (
          <Paper
            elevation={0}
            sx={{
              mt: 2,
              width: "100%",
              p: 4,
              background: "rgba(0, 0, 0, 0.125)",
              border: 0,
              textAlign: "center",
            }}
          >
            No sources
          </Paper>
        )}
      </>
    );
  }
);

export default EnvironmentSourcesSearchPage;
